import FetchUtils from '../utils/fetch.utils';

export default class CardService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_CARDS}/api/cards`;

  static list = async () => {
    return FetchUtils.get(CardService.BASE_URL);
  };

  static get = async organization => {
    return FetchUtils.get(
      `${CardService.BASE_URL}?organizationCode=${organization}`,
    );
  };

  static getInvitations = async () => {
    return FetchUtils.get(`${CardService.BASE_URL}/invitations`);
  };

  static getSettings = async organization => {
    return FetchUtils.get(
      `${CardService.BASE_URL}/settings?organizationCode=${organization}`,
    );
  };

  static requestNewCard = async (organization, cardUid) => {
    return FetchUtils.put(
      `${CardService.BASE_URL}/status?organizationCode=${organization}&cardUid=${cardUid}`,
      { status: 'replace' },
    );
  };

  static updateStatus = async (organization, status, cardUid) => {
    return FetchUtils.put(
      `${CardService.BASE_URL}/status?organizationCode=${organization}&cardUid=${cardUid}`,
      { status },
    );
  };

  static getAtms = async organization => {
    return FetchUtils.get(
      `${CardService.BASE_URL}/banks?organizationCode=${organization}`,
    );
  };

  static activate = async data => {
    return FetchUtils.post(`${CardService.BASE_URL}`, data);
  };

  static setPin = async (organization, cardUid, body = null) => {
    return FetchUtils.post(
      `${CardService.BASE_URL}/pin?organizationCode=${organization}&cardUid=${cardUid}`,
      body,
      {
        headers: {
          'x-api-version': 'v3',
        },
      },
    );
  };

  static setPinStatus = async (organization, cardUid, status) => {
    return FetchUtils.put(
      `${CardService.BASE_URL}/pin?organizationCode=${organization}&cardUid=${cardUid}`,
      {
        status,
      },
    );
  };
}
